import { ControlSheetRouteDTO } from '@/types/controlsheet'
import styles from './ControlSheetRoutePicker.module.scss'
import clsx from 'clsx'
import ArrowRight from '../../assets/arrow-right.svg'

interface Props {
    routes: ControlSheetRouteDTO[]
    selectedRoute: number
    setSelectedRoute: (route: number) => void
}

export const ControlSheetRoutePicker = ({ routes, selectedRoute, setSelectedRoute }: Props) => {
    const smallButton = (route: ControlSheetRouteDTO, index: number) => {
        return (
            <div
                key={`route-${index}`}
                className={clsx(styles.routeContainer, {
                    [styles.routeActive]: index === selectedRoute,
                })}
                onClick={() => setSelectedRoute(index)}
            >
                <span
                    className={clsx(styles.routeLabel, {
                        [styles.routeLabelActive]: index === selectedRoute,
                    })}
                >
                    {`Route ${route.route}`}
                </span>
            </div>
        )
    }

    const largeButton = (route: ControlSheetRouteDTO, index: number) => {
        return (
            <div
                key={`route-${index}`}
                className={clsx(styles.routeContainer, {
                    [styles.routeActive]: index === selectedRoute,
                })}
                onClick={() => setSelectedRoute(index)}
            >
                <div
                    className={clsx(styles.routeLabel, {
                        [styles.routeLabelActive]: index === selectedRoute,
                    })}
                >
                    Route {route.route}
                </div>
                <div
                    className={clsx(styles.routeTerminus, {
                        [styles.routeTerminusActive]: index === selectedRoute,
                    })}
                >
                    {route.departure} <ArrowRight /> {route.arrival}
                </div>
            </div>
        )
    }

    return (
        <div className={styles.routesWrapper}>
            <div className={styles.routesContainer}>
                {routes.map((route: ControlSheetRouteDTO, index: number) => {
                    if (routes.length > 5) {
                        return smallButton(route, index)
                    }
                    return largeButton(route, index)
                })}
            </div>
        </div>
    )
}
